module.exports = __webpack_public_path__ + "static/paypal-27881c9529658075e582d34b06b324bf.png";